import { UserContext } from "context/userContext"
import { UserModel } from "model/UserModel"
import { FC, ReactNode, useContext } from "react"
import { Navigate } from "react-router-dom"
import { canOpenPage, getHomeUrl } from "util/route"

interface RouteGuardProps {
  // Адрес пункта сайдбара (как в configuration). Без него — страница вне
  // сайдбара, только для админов
  url?: string
  children: ReactNode
}

// Заблокированные в сайдбаре страницы не открываются и по прямой ссылке —
// уводим на главную. Админам можно всё
export const RouteGuard: FC<RouteGuardProps> = ({ url, children }) => {
  const user = useContext<UserModel>(UserContext)

  if (canOpenPage(url, user)) {
    return <>{children}</>
  }

  const homeUrl = getHomeUrl(user)
  return homeUrl ? <Navigate to={`/${homeUrl}`} replace /> : null
}
